const BookmarksReducer = (state, { type, payload }) => {
  switch (type) {
    case "INIT_BOOKMARKS":
      return {
        ...state,
        bookmarks: payload,
      };

    case "ADD_TO_BOOKMARKS":

    const exists = state.bookmarks.find((item) => item._id === payload._id);
    if (exists) return state;

    return {
      ...state,
      bookmarks: [...state.bookmarks, payload],
    };

    case "REMOVE_BOOKMARK":
      return {
        ...state,
        bookmarks: state.bookmarks.filter((item) => item._id !== payload),
      };

    case "CLEAR_FILTER":
      return {
        ...state,
        bookmarks: [],
      };

    default:
      return state;
  }
};

export default BookmarksReducer;
